import type { ApiISODateTimeString } from '#/api/types/ApiTypedDate';

export function isListingExpired(expires: ApiISODateTimeString) {
  return new Date(expires).getTime() < new Date().getTime();
}
